import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import FeaturedProducts from './components/FeaturedProducts';
import Shop from './components/Shop';
import About from './components/About';
import Feedback from './components/Feedback'; // Добавьте эту строку
import Contacts from './components/Contacts';
import Footer from './components/Footer';
import ProductModal from './components/ProductModal';
import './App.css';

function App() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const openProductModal = (product) => {
    setSelectedProduct(product);
  };

  const closeProductModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="App">
      <Header />
      <Hero />
      <FeaturedProducts onProductClick={openProductModal} />
      <Shop onProductClick={openProductModal} />
      <About />
      <Feedback /> {/* Добавьте эту строку */}
      <Contacts />
      <Footer />

      {selectedProduct && (
        <ProductModal 
          product={selectedProduct} 
          onClose={closeProductModal} 
        />
      )}
    </div>
  );
}

export default App;